import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  Output
} from '@angular/core';
import { SelectChangeEvent } from 'primeng/select';
import { Table } from 'primeng/table';
import { BlobFileDownloadRequestModel } from '../../../models/blob-file-sas-url.model';
import { PartnerWorkshopHistory } from '../../../models/partner-workshop-response.model';
import { PartnerListUploadItem } from '../../../models/private-workshop-response.model';
import { AppConstants } from '../../common/app-constants';
import { PartnerWorkshopApi } from '../../services/partner-workshop.service';
import { AccessListErrorLogComponent } from '../access-list-error-log/access-list-error-log.component';
import { PartnerDocumentUploadComponent } from '../partner-document-upload/partner-document-upload.component';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-partner-upload-history',
  templateUrl: './partner-upload-history.component.html',
  styleUrls: ['./partner-upload-history.component.scss'],
  standalone: true,
  imports: [
    AccessListErrorLogComponent,
    PartnerDocumentUploadComponent,
    CommonSharedModule
  ]
})
export class PartnerUploadHistoryComponent implements OnInit {
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  scrollableCols = new Array<any>();
  partnerWorkshopUploadHistory!: PartnerWorkshopHistory[];
  originalWorkshopUploadHistory!: PartnerWorkshopHistory[];
  fileTypes = new Array<any>();
  globalFilterCols = new Array<any>();
  totalRecords!: number;
  filterValue!: string;
  tblPageNumber = 1;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('uploadDocumentDialogue', { static: false })
  uploadDocumentDialogue!: PartnerDocumentUploadComponent;
  @ViewChild('viewLogModal', { static: false })
  viewLogModal!: AccessListErrorLogComponent;
  showLogs = false;
  partnerListUploadItem!: PartnerListUploadItem;
  workshopTypeId!: number;
  isHybridWithCustomerList = false;
  @Output() hybridWithCustomerListChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  constructor(private partnerworkshopservice: PartnerWorkshopApi) {}

  ngOnInit() {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage =
      AppConstants.partnerworkshopUploadHistoryRecsPerPage;
    this.loading = false;

    this.scrollableCols = [
      { field: 'active', header: 'Active' },
      { field: 'documentDisplayName', header: 'File Name' },
      { field: 'fileType', header: 'File Type' },
      { field: 'createdOn', header: 'Upload Date' },
      { field: 'createdByUserAlias', header: 'Uploaded by' },
      { field: 'errors', header: 'Errors' }
    ];

    this.fileTypes = [{ type: 'Partner' }, { type: 'Customer' }];
    this.globalFilterCols = ['createdOn', 'fileType'];
    this.showLogs = false;
  }

  pageChange(e: { first: number }): void {
    this.tblPageNumber = e.first / this.dataViewRecsPerPage + 1;
    this.loadWorkshopUploadHistory(this.workshopTypeId);
  }

  filterTable(event: SelectChangeEvent): void {
    if ((event as any).value !== null) {
      this.filterValue = (event as any).value.type;
      const filteredData = this.originalWorkshopUploadHistory.filter(item =>
        item.fileType.includes(this.filterValue)
      );
      this.partnerWorkshopUploadHistory = filteredData;
    } else {
      this.partnerWorkshopUploadHistory = [
        ...this.originalWorkshopUploadHistory
      ];
    }
  }

  loadWorkshopUploadHistory(workshopTypeId: number): void {
    this.workshopTypeId =
      workshopTypeId !== null ? workshopTypeId : this.workshopTypeId;
    this.loading = true;
    this.partnerworkshopservice
      .getPartnerWorkshopHistory(
        this.workshopTypeId,
        this.tblPageNumber,
        this.dataViewRecsPerPage
      )
      .subscribe(response => {
        this.loading = false;
        this.originalWorkshopUploadHistory = [...response.results];
        if (this.filterValue == 'Partner' || this.filterValue == 'Customer') {
          const filteredData = this.originalWorkshopUploadHistory.filter(item =>
            item.fileType.includes(this.filterValue)
          );
          this.partnerWorkshopUploadHistory = filteredData;
        } else {
          this.partnerWorkshopUploadHistory = response.results;
        }
        this.totalRecords = response.rowCount;
        this.tblPageNumber = response.currentPage;
      });
  }

  showUploadDialog(): void {
    this.hybridWithCustomerListChange.emit(this.isHybridWithCustomerList);
    this.uploadDocumentDialogue.selectedWorkshopType = this.workshopTypeId;
    this.uploadDocumentDialogue.showDialog();
  }

  viewLog(uploadResult: PartnerListUploadItem, fileType: string): void {
    this.viewLogModal.loadError(uploadResult, fileType, false);
    this.showLogs = true;
  }

  get isWorkshopTypeSelected(): boolean {
    return this.workshopTypeId ? true : false;
  }

  async downloadFile(selectedFile: PartnerWorkshopHistory): Promise<void> {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.documentDisplayName,
      fileUrl: selectedFile.documentBlobUrl
    };
    const downloadFileSasUrl = await this.partnerworkshopservice
      .getDownloadFileUrl(blobFileDownloadRequestModel)
      .toPromise();
    const a = document.createElement('a');
    a.href = downloadFileSasUrl || '';
    a.target = '_blank';
    a.download = selectedFile.documentDisplayName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
